export function normalizeValueByMode(value, mode) {
  const isMultiple = ['multiple', 'tags'].includes(mode);

  return isMultiple ? value ?? [] : value;
}
